import CourtCaseConnectionType from "../model/CourtCaseConnectionType";

const CourtCaseConnectionTypeMapper = (item: any) => {
  let courtCaseConnectionType = CourtCaseConnectionType(item);
  return courtCaseConnectionType;
};

export default CourtCaseConnectionTypeMapper;
